import { Component, OnDestroy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from './services/auth.service';
import { SubSink } from 'subsink';
import { User } from './models/user';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
  standalone: true
})
export class AppComponent implements OnDestroy {
  subs = new SubSink();

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }



  ngOnInit() {
    this.subs.add(
      this.authService.user$.subscribe((user: User | null) => {
        if (user && this.router.url === '/login') {
          this.router.navigate(['/requests']);
        }
      })
    );
  }
}
